







import EmbeddedChatBody from '@/components/EmbeddedChatBody.vue';
import EmbeddedChatBottom from '@/components/EmbeddedChatBottom.vue';
import { Client, RequestType, ClientEvent, ActionType, Action, Store} from 'jovo-client-web-vue';
import { Component, Vue } from 'vue-property-decorator';
import * as https from 'https';

export interface UserPlus {
    id: string;
}

@Component({
  name: 'embedded-chat',
  components: { EmbeddedChatBody, EmbeddedChatBottom },
})
export default class EmbeddedChat extends Vue {


/*
  async mounted() {
    await this.$client.initialize();
  if(this.$route.query.demo)
      await this.$client.createRequest({ type: RequestType.Launch, body: { text: this.$route.query.demo.toString()} }).send();
    else
      await this.$client.createRequest({ type: RequestType.Launch }).send();
    this.$client.on(ClientEvent.Action, this.onAction);
  }

  private onAction(action: Action) {
    if (action.type === ActionType.Custom) {
      switch (action.command) {
        case 'redirect':
          setTimeout(() => {
              window.open(action.value);
          }, 800);
          break;
        case 'login':
            break;
        default:
      }
    }
  }
*/
}
